import { CLOSE_HELP, SHOW_HELP, RESET_HELP_SECTION_TOPIC } from '@app/actions/_types';

const initialHelpState = {
  activated: false,
  currentHelpSection: null,
  currentHelpSectionTopic: null,
  triggerElement: null,
};

export default (state = initialHelpState, { type, payload } = {}) => {
  switch (type) {
    case CLOSE_HELP:
      return {
        ...state,
        activated: false,
        currentHelpSection: null,
        currentHelpSectionTopic: null,
        triggerElement: null,
      };
    case SHOW_HELP: {
      const { helpSection, helpTopic, triggerElement } = payload;
      return {
        ...state,
        activated: true,
        currentHelpSection: helpSection,
        currentHelpSectionTopic: helpTopic,
        triggerElement,
      };
    }
    case RESET_HELP_SECTION_TOPIC:
      return {
        ...state,
        currentHelpSectionTopic: null,
      };
    default:
      return state;
  }
};
